export default __webpack_public_path__ + "static/media/certificationbanner.155213d8.png";